export interface ITemporaryUserResetEmail {
    id?: number;
    indicatif?: string; 
    phoneNumber?: string;
    username?: string;
    oldEmail?: string;
    newEmail?: string;
    createdDate?: Date;
    expirationDate?: Date;
    firstName?: string;
    lastName?: string;
  }
  
  export class TemporaryUserResetEmail implements ITemporaryUserResetEmail {
    constructor(
      public id?: number,
      public indicatif?: string,
      public phoneNumber?: string,
      public username?: string,
      public oldEmail?: string,
      public newEmail?: string,
      public createdDate?: Date,
      public expirationDate?: Date,
      public firstName?: string,
      public lastName?: string,
    ) {
      this.id = id;
      this.indicatif = indicatif;
      this.phoneNumber = phoneNumber;
      this.username = username;
      this.oldEmail = oldEmail;
      this.newEmail = newEmail;
      this.createdDate = createdDate;
      this.expirationDate = expirationDate;
      this.firstName = firstName;
      this.lastName = lastName;
    }
  }